import { Box } from "@mui/material"
import { alpha } from "@mui/material/styles"
import Iconify from "minimals-template/components/Iconify"

export function RegimeImagePlaceholder({ size, iconSize = 42, sx }) {
    return (
        <Box
            data-cy="regime-image-placeholder"
            sx={{
                width: size ?? 1,
                height: size ?? 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: iconSize,
                bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                color: "grey.500",
                ...sx,
            }}
        >
            <Iconify icon="solar:buildings-line-duotone" />
        </Box>
    )
}
